<template>
    <div v-if="projeto.convenio">
        <h4 class="heading-1 mt-3">
            <span>CONVÊNIO</span>
        </h4>
        <b-row>
            <b-col sm="12" md="4">
                <app-k-v
                    titulo="Código"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.convenio.codigoConvenio"
                ></app-k-v>
                <app-k-v
                    titulo="Objeto"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.convenio.nomeConvenio"
                ></app-k-v>
                <app-k-v
                    titulo="Tipo"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.convenio.tipoConvenio"
                ></app-k-v>
                <app-k-v
                    titulo="Fornecedor"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.convenio.fornecedor"
                ></app-k-v>
                <app-k-v
                    titulo="Gestor"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.convenio.gestor"
                ></app-k-v>
                <app-k-v
                    titulo="Gerente"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                    :dado="projeto.convenio.gerente"
                ></app-k-v>
                <app-k-v
                    titulo="Valor Total"
                    :md="md"
                    :lg="lg"
                    :xl="xl"
                >
                    <strong>{{
                        projeto.convenio.valorConvenio | currency
                    }}</strong>
                </app-k-v>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    props: {
        projeto: {
            type: Object
        }
    },

    data() {
        return {
            xl: 3,
            lg: 3,
            md: 2
        }
    },
}

</script>